import * as yup from "yup";
import { MSG } from "../constants/MSG";

const newPasswordrgx =
	"^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,20}$";

export const loginSchema = yup.object().shape({
	emailId: yup
		.string()
		.trim()
		.email(MSG.REQUIRED_PROPER_EMAIL)
		.required(MSG.REQUIRED_EMAIL),
	password: yup
		.string()
		.trim()
		.required(MSG.REQUIRED_PASSWORD)
		.matches(newPasswordrgx, MSG.REQUIRED_VALID_PASSWORD),
});

export const forgotPasswordSchema = yup.object().shape({
	email: yup
		.string()
		.trim()
		.email(MSG.REQUIRED_PROPER_EMAIL)
		.required(MSG.REQUIRED_EMAIL),
});

export const updatePasswordSchema = yup.object().shape({
	newPassword: yup
		.string()
		.trim()
		.min(8)
		.max(20)
		.required(MSG.PROVIDE_PROPER_PASSWORD),
	confirmPassword: yup
		.string()
		.trim()
		.min(8)
		.max(20)
		.oneOf([yup.ref("newPassword"), null], MSG.PASSWORDS_DO_NOT_MATCH)
		.required(MSG.PROVIDE_PROPER_PASSWORD),
});
